module.exports = __webpack_public_path__ + "media/assets/images/blog/TESTA-LINKEDIN-2-d25c67a61153fdfa8f2421d8d383f138.jpg";